'use client';
import React from 'react';

export default function CallToActionSection() {
  return (
    <section id="call-to-action" className="call-to-action section dark-background">
      {/* Background image */}
      <img src="/assets/img/cta-bg.jpg" alt="Call to Action Background" />

      <div className="container">
        <div className="row justify-content-center" data-aos="zoom-in" data-aos-delay="100">
          <div className="col-xl-10">
            <div className="text-center">
              <h3>Need Reliable Manpower or Tender Support?</h3>
              <p>
                SMART SERVICE is your trusted partner for skilled, semi-skilled, and unskilled workforce solutions across Gujarat and India. From private projects to government tenders — we’ve got you covered.
              </p>
              <a className="cta-btn" href="#contact">
                Call To Action
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
